import { createIcon } from '@/utils/factoryUtil'

export const SVGBrandStarCityGames = createIcon('SVGBrandStarCityGames', (props) => (
  <svg viewBox='0 0 100 100' {...props}>
    <path d='M49.38,77.23l-28.99,20.18c-.84.59-1.95-.22-1.65-1.2l10.23-33.81c.13-.43-.02-.9-.38-1.18L.43,39.88c-.82-.62-.39-1.92.63-1.95l35.32-.72c.45,0,.85-.3,1-.73L48.98,3.12c.34-.97,1.71-.97,2.05,0l11.6,33.37c.15.43.55.72,1,.73l35.32.72c1.03.02,1.45,1.33.63,1.95l-28.15,21.34c-.36.27-.51.74-.38,1.18l10.23,33.81c.3.98-.81,1.79-1.65,1.2l-28.99-20.18c-.37-.26-.87-.26-1.24,0h0Z' />
  </svg>
))
